export default __webpack_public_path__ + "images/IB.7be4d75.png";